const isDev = false;

export const config = {
  env: isDev ? "dev" : "prod", // dev || prod
  version: "0.1.2",
};
